import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Setup Completed Guard - Protects routes that require completed account setup
 * 
 * This guard checks if the user's account setup is completed.
 * If not completed, the user is restricted from accessing the route.
 * The 'Layout' component will typically handle showing the 'Under Review' screen
 * if this guard is applied to children of the Layout.
 * 
 * Usage in routes:
 * {
 *   path: 'dashboard',
 *   component: DashboardComponent,
 *   canActivate: [authGuard, setupCompletedGuard]
 * }
 */
export const setupCompletedGuard: CanActivateFn = () => {
    // We allow the navigation to proceed because the 'Layout' component
    // already handles the UI protection via @if (authService.isAccountSetupCompleted()).
    // Returning 'false' here without a redirect would cancel the entire 
    // navigation chain, potentially leading to blank pages.

    return true;
};
